"use client";
import { Image } from "@/components/Image";
import Link from "next/link";
import { PrimaryButton } from "ui/components";
import { ArrowRightIcon } from "ui/iconsN";

export const DevenirSpeaker = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10 my-16 md:my-28">
      <div className="relative lg:pl-[178px] lg:pb-[164px]">
        <h2 className="text-2xl lg:text-[28px] font-semibold font-serif">
          Devenir <span className="italic font-normal">guide-conférencier</span>
        </h2>
        <div className="mt-2 lg:mt-3">
          Rejoignez notre équipe de plus de <span className="font-semibold">130 guide-conférenciers passionnés !</span>
        </div>
        <Link href="/entreprise/devenir-guide-conferencier/">
          <PrimaryButton className="mt-4 hidden md:inline-block">
            Découvrir nos offres
            <ArrowRightIcon />
          </PrimaryButton>
        </Link>
        <div className="w-[210px] absolute left-0 bottom-0 hidden lg:block pointer-events-none">
          <Image
            alt="Conférencier"
            image={{
              type: "asset",
              name: "f_speaker_2.png",
              realname: "f_speaker_2.png",
            }}
            sizes="440px"
            objectFit="cover"
            height={{
              type: "ratio",
              value: 112.3809,
            }}
          />
        </div>
      </div>
      <div>
        <Image
          className="max-md:pb-[66.666%] md:h-full rounded-xl"
          alt="Guide-conférencier"
          image={{
            type: "asset",
            name: "b_speaker_1.png",
            realname: "b_speaker_1.png",
          }}
          sizes="440px"
          objectFit="cover"
        />
      </div>
      <div className="md:hidden mt-2 flex justify-center">
        <Link href="/entreprise/devenir-guide-conferencier/">
          <PrimaryButton>
            Découvrir nos offres
            <ArrowRightIcon />
          </PrimaryButton>
        </Link>
      </div>
    </div>
  );
};
